<div class="ts-chip-collection-wrapper">
  <ng-content></ng-content>
</div>
